import { chakra } from '@chakra-ui/react-v2';
import type { PropsWithChildren } from 'react';

import { useDragSummaryStyles } from './DragSummaryStylesContext';

export type DraggedItemDescriptionProps = PropsWithChildren<unknown>;

export const DraggedItemDescription = ({
  children,
}: DraggedItemDescriptionProps) => {
  const { draggedItemDescription: draggedItemDescriptionStyles } =
    useDragSummaryStyles();

  return <chakra.p __css={draggedItemDescriptionStyles}>{children}</chakra.p>;
};
